import { gql } from "@apollo/client"

export const CalendarDurationFragment = gql`
  fragment CalendarDurationFragment on CalendarDuration {
    unit
    value
  }
`

export const CalendarDurationRangeFragment = gql`
  fragment CalendarDurationRangeFragment on CalendarDurationRange {
    max {
      ...CalendarDurationFragment
    }
    min {
      ...CalendarDurationFragment
    }
  }
`

export const AllowancesRulesFragment = gql`
  fragment AllowancesRulesFragment on CountryIntelligenceRulesAllowances {
    type
    partOfGrossSalary
    paidWhen
    oysterScore
    value
    approximation
  }
`

export const ProbationRulesFragment = gql`
  fragment ProbationRulesFragment on CountryIntelligenceRulesProbation {
    duration {
      ...CalendarDurationFragment
    }
    oysterScore
    employmentType
    teamMemberLevel
    teamMemberSeniorities
    extension {
      deadline {
        ...CalendarDurationFragment
      }
      maxAdditionalDuration {
        ...CalendarDurationFragment
      }
    }
    tenureRange {
      ...CalendarDurationRangeFragment
    }
  }

  ${CalendarDurationFragment}
  ${CalendarDurationRangeFragment}
`

export const ResignationRulesFragment = gql`
  fragment ResignationRulesFragment on CountryIntelligenceRulesResignation {
    duringProbation
    tenureRange {
      ...CalendarDurationRangeFragment
    }
    notice {
      ...CalendarDurationFragment
    }
  }

  ${CalendarDurationFragment}
  ${CalendarDurationRangeFragment}
`

export const TerminationRulesFragment = gql`
  fragment TerminationRulesFragment on CountryIntelligenceRulesTermination {
    duringProbation
    tenureRange {
      ...CalendarDurationRangeFragment
    }
    notice {
      ...CalendarDurationFragment
    }
  }

  ${CalendarDurationFragment}
  ${CalendarDurationRangeFragment}
`

export const TimeOffRulesFragment = gql`
  fragment TimeOffRulesFragment on CountryIntelligenceRulesTimeOff {
    type
    amountPerYear {
      ...CalendarDurationFragment
    }
    oysterScore
  }

  ${CalendarDurationFragment}
`

export const RestrictiveCovenantsRules = gql`
  fragment RestrictiveCovenantsRules on CountryIntelligenceRulesRestrictiveCovenants {
    postTermination(
      nonCompetition: $nonCompetition
      nonSolicitationEmployees: $nonSolicitationEmployees
      nonSolicitationCustomers: $nonSolicitationCustomers
    ) {
      paymentRequired
      maxDuration {
        unit
        value
      }
      suggestedDurations {
        unit
        value
      }
      paymentRules {
        amountType
        frequencyRules {
          amountTopOfMarket {
            flat {
              currencyCode
              subunit
              subunitToUnit
              formatted
            }
            percentage
          }
          amountRecommended {
            flat {
              currencyCode
              subunit
              subunitToUnit
              formatted
            }
            percentage
          }
          amountStatutory {
            flat {
              currencyCode
              subunit
              subunitToUnit
              formatted
            }
            percentage
          }
          frequency
          restrictedAreaRules {
            additionalAreasAllowed
            restrictedArea
            amountTopOfMarket {
              flat {
                currencyCode
                subunit
                subunitToUnit
                formatted
              }
              percentage
            }
            amountRecommended {
              flat {
                currencyCode
                subunit
                subunitToUnit
                formatted
              }
              percentage
            }
            amountStatutory {
              flat {
                currencyCode
                subunit
                subunitToUnit
                formatted
              }
              percentage
            }
          }
        }
      }
    }
    restrictedClauses(countryCode: $countryCode, subdivisionCode: $subdivisionCode) {
      nonCompetition
      nonSolicitation
      nonSolicitationCustomers
      nonSolicitationEmployees
    }
  }
`
